const HIDE_GRACE_MS = 150;

export class DropdownVisibility {
  constructor(ui) {
    this.ui = ui;
    this.hideTimer = null;
  }

  show = () => {
    this.cancelPendingHide();
    this.ui.show();
  };

  scheduleHide = () => {
    this.cancelPendingHide();
    this.hideTimer = setTimeout(this.ui.hide, HIDE_GRACE_MS);
  };

  cancelPendingHide = () => {
    clearTimeout(this.hideTimer);
  };

  closeAndReturnFocus = () => {
    this.cancelPendingHide();
    this.ui.hide();
    this.ui.focusOption();
  };

  closeAndFocusNextOption = () => {
    this.cancelPendingHide();
    this.ui.hide();
    this.ui.focusNextOption();
  };
}
